
import db_lib from 'xAppLib/libs/db_lib';
// import React from 'react'
import API_service from 'xAppLib/providers/API_service'
import obj_filter_by_key from "../xAppLib/helpers/obj_filter_by_key";


export const TYPE_DICT = (s, r) => s=='doccons' && r=='followup' && "Dr Follow Up"
				|| s=='doccons' && r=='docord' && "Dr FU Req"
				|| s=='doccons' && r=='doccons_fu' && "Pt FU Req"
				|| s=='doccons' && r=='followup_cron' && "Sched Follow Up"
				|| s=='doccons' && r=='followup_res' && "Result Follow Up"
				|| s=='doccons' && r=='docconswl' && "Wght Loss Consult"
				|| s=='doccons' && r=='docconswli' && "Wght Loss Cons (Injection)"
				|| s=='doccons' && r=='docconswlo' && "Wght Loss Cons (Oral)"
				|| s=='doccons' && r=='menopauseconsult' && "Menopause Consult"
				|| s=='pathoreq' && ['docconswl','docconswli','docconswlo','subconswl','subconswlfu'].includes(r) && "Wght Loss Patho Req"
				|| s=='doccons' && r=='docconsref' && "Spec Ref Consult"
				|| s=='doccons' && r=='docconssc' && "Smok Cess Cons"
				|| s=='doccons' && r=='ileg' && "Legal Ref Consult"
				|| s=='doccons' && r=='icann' && "Cannabis Consult"
				|| s=='doccons' && r=='ihair' && "Hair Consult"
				|| s=='doccons' && r=='dc_av' && "Antiviral Consult"
				|| s=='doccons' && r=='dc_rh' && "RoseHeal Consult"
				|| s=='doccons' && r=='dc_uti' && "UTI Consult"
				|| s=='doccons' && r=='dc_skin' && "Skin Consult"
				|| s=='doccons' && r=='dc_acne' && "Acne Consult"
				|| s=='doccons' && r=='dc_pe' && "PE Consult"
				|| s=='doccons' && r=='dc_fertility' && "Fertility Cons"
				|| s=='doccons' && r=='dc_sti' && "STI Consult"
				|| s=='doccons' && r=='mhcp' && "MHCP Consult"
				|| s=='doccons' && r=='mhcprev' && "MHCP Review"
				|| s=='doccons' && r=='dcs_cert' && 'Short Cons Cert'
				|| s=='doccons' && r=='dcs_refr' && 'Short Cons Spec Ref'
				|| s=='doccons' && r=='dcs_patho' && 'Short Cons Patho Ref'
				|| s=='doccons' && r=='dcs_scr' && 'Single Prescription'
				|| s=='doccons' && "Dr Consult"
				|| s=='subcons' && r=='subconswl'   && "Wght Loss Sub Consult"
				|| s=='subcons' && r=='subconswlfu' && "Wght Loss Sub FU"
				|| s=='subcons' && SUBSC_TYPE_DICT[r]
				|| s=='medsub' && "Subscr Med"
				|| s=='subcons' &&  "Treatment Plan Consult"
				|| s=='docscr' && "Dr Script"
				|| s=='docrefr' && r=='doccons' && "Dr Referral"
				|| s=='docrefr' && "Expr Dr Refr"
				|| s=='doclett' && "Dr Letter"
				|| s=='mentplan' && "MHCP"
				|| s=='fertilityrefr' && "Adora Fertility Refr"
				|| s=='mentrev' && "MHCP Review"
				|| s=='sleeprefr' && "Dr Sleep Refr"
				|| s=='medcert' && r=='doccons' && "Dr MedCert"
				|| s=='medbuy' && "Med Deliv"
				|| s=='medclick' && "Med Click"
				|| s=='exprbuy' && "Med Deliv+Cons"
				|| s=='exprclick' && "Med Click+Cons"
				|| s=='qualbuy' && "Med Deliv+Review"
				|| s=='qualclick' && "Med Click+Review"
				|| s=='medcons' && r=='medcert' && "App MedCert"
				|| s=='medcons' && "App Script"
				|| s=='exprcons'&& r=='medcert'  && "App MedCert+Cons"
				|| s=='exprcons'&& r=='xc_patho'  && "Pathology+Cons"
				|| s=='exprcons' && "App Script+Cons"
				|| s=='qualcons' && "App Script+Review"
				|| s=='medcert' && r=='pharm' && "Pharm MedCert"
				|| s=='pharm' && r=='medcert' && "Pharm MedCert"
				|| s=='pharm' && "Pharm Script"
				|| s=='instcons' && r=='cosm' && "InstCons Cosm"
				|| s=='cosmscr' && r=='cosm' && "Cosm Script"
				|| s=='cosm' && "Cosm Script"
				|| s=='tpcons' && r == 'cosm' && 'Cosmetic Treatment Plan Consult'
				|| s=='tprev' && r == 'cosm' && 'Cosmetic Treatment Plan Review'
				|| s=='tprpt' && r == 'cosm' && 'Cosmetic Retreatment'
				|| s=='tptopup' && r == 'cosm' && 'Cosmetic Top-up'
				|| s=='custadm' && "Admin Script"
				|| s=='pathoreq' && ['premed', 'remed'].includes(r) && 'Patho Req fr App'
				|| s=='pathoreq' && r=='doccons' && 'Patho Req fr Doc'
				|| s=='medimgreq' && r=='doccons' && 'MedImg Req fr Doc'
				|| s=='exscr' && r=='erepeat' && 'Ext. eRepeat'
				|| s + '-' + r;
// Shouldn't need this any more, but leaving just for existing treatment plans
const SUBSC_TYPE_DICT = {
	subconsasm: 'Asthma Treat Plan',
	subconshb: 'Heartburn Treat Plan',
	subconschol: 'Cholesterol Treat Plan',
	doccons_fu: 'Treat Plan FU Req'
};

export default class scripts_list_model_base extends db_lib {


	// static get FRDB_LOC() { return _FRDB_LOC + (scripts_list_model_base.alt_db||''); }
	static get TYPE_DICT() { return TYPE_DICT; }


	static set_db(c) {
		this.alt_db = c || false;
	}

	// ---- --------------------------------------------  --------------------------------------------
	// ---- --------------------------------------------  --------------------------------------------

	static load_scripts_list( params, ca, ce ) {

		return new Promise((resolve,reject)=>{
			API_service.call_api(
										'getScriptsList',
										params,
										// 'post_form_cred', null,
										r => {
											resolve(r)
											ca && ca(r)
										},
										r => {
											reject(r);
											ce && ce(r);
										},
								)

		})
		
	}

	// ---- --------------------------------------------  --------------------------------------------
	// ---- --------------------------------------------  --------------------------------------------

	static load_by_sid(sid, params = {}) {
		return this.load_scripts_list({ ...params, filters: {...params.filters, sid }}).then(res => {
			if (res.res === 'ok') {
				const count = (res.listScripts || []).length;
				if (count === 1) {
					return res.listScripts[0];
				}
				return null;
			}
			return Promise.reject(new Error(res.err || `Error loading script ${sid}`));
		});
	}

	// 		--------------------------------		--------------------------------		---------
	// 		--------------------------------		--------------------------------		---------

	static async load_remed_data({sid, mid, include_sub}) {
		const remed_scr = await API_service.load_data('remedScr', {sid, mid, include_sub});

		if (remed_scr) {
			const clean_remed_fields = obj => {
				return obj_filter_by_key(obj, key => !(
					obj[key] === '.' || ['fulfilment', 'medication', 'delivery', 'medicare', 'conc_card'].includes(key)
				));
			}

			return {
				...remed_scr,
				form_data: clean_remed_fields(remed_scr.form_data),
				spd_data: clean_remed_fields(remed_scr.spd_data),
			}
		}

		return null;
	}

    static stats_dict (stat) {

		if ((app.user.claims.admin 
					|| app.user.claims.supp
					|| app.user.claims.doc 
					|| app.user.claims.mang 
					|| app.user.claims.pharm)
				&& ['auto_approved', 'approved', 'doc_approved'].includes(stat))
						return app.user.claims.root && stat || 'approved';

		if ((app.user.claims.admin 
					|| app.user.claims.supp
					|| app.user.claims.doc 
					|| app.user.claims.mang 
					|| app.user.claims.pharm)
				&& ['doc_issued'].includes(stat))
						return 'Dr issued';

		if (['followup_doccall'].includes(stat))
						return 'Follow up doctor call';

		if (['await_doccall'].includes(stat))
						return 'Awaiting doctor call';

		if (['noans_doccall'].includes(stat))
						return 'No answer to doctor call';

		if (['wrong_number'].includes(stat))
						return 'Wrong number';

		if (['in_doccall'].includes(stat))
						return 'Consult in progress';

		if (['done_doccall'].includes(stat))
						return 'Consult finished';

		if (['done_auto'].includes(stat))
						return 'Consult finished (auto)';

		if ('await_escript'==stat)
				return 'eScript Pending'
		
		if ('stuck_escript'==stat)
				return 'eScript Stuck'

		if ('stuck_escript_noti'==stat)
				return 'eScript Stuck (Notified)'

		if (['expr_declined', 'qual_declined'].includes(stat))
			return 'Consult finished (declined)';

		if (['wrong details'].includes(stat))
			return 'Consult cancelled (wrong details)';

		if(stat === 'on_hold') return 'On Hold';

		if(stat === 'cancelled') return 'Cancelled';

		if(stat === 'could_not_call') return 'Could not call';

		if(['scheduled', 'instcons_scheduled'].includes(stat)) return 'Scheduled';

		return stat
	}
}